// extracted by mini-css-extract-plugin
module.exports = {"mw":"MeriamWebsterPronunciation_mw__3nQjP","mw__play":"MeriamWebsterPronunciation_mw__play__FosYL","mw__stop":"MeriamWebsterPronunciation_mw__stop__zzWNC"};